<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <h2 ngpDialogTitle>{{ text.title }}</h2>

    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="dismiss()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <p class="rejected-intro">{{ text.intro }}</p>

    <ul class="rejected-list">
      @for (rejection of rejections; track rejection.key) {
        <li class="rejected-item">
          <code class="rejected-item__key">{{ rejection.key }}</code>
          <p class="rejected-item__message">{{ rejection.message }}</p>
          <p class="rejected-item__route">
            {{ text.routeLabel }}: <code>{{ rejection.route }}</code>
          </p>
        </li>
      }
    </ul>

    <h4 class="rejected-fix__title">{{ text.fixTitle }}</h4>
    <ol class="rejected-fix__steps">
      @for (step of text.fixSteps; track step) {
        <li>{{ step }}</li>
      }
    </ol>
  </ng-template>

  <ng-template suiDialogFooter>
    <sui-button
      variant="secondary"
      [leadingIcon]="['fas', 'copy']"
      (click)="copyDetails()"
    >
      {{ copied ? text.copiedButton : text.copyButton }}
    </sui-button>
    <sui-button variant="primary" (click)="dismiss()">
      {{ text.dismissButton }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
